import React, { useState, useEffect } from "react";

//import React, { useState } from "react";
import {
  Grid,
  Select,
  OutlinedInput,
  MenuItem,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
} from "recharts";
// styles
import useStyles from "./styles";

// components
import PageTitle from "../../components/PageTitle";
import Widget from "../../components/Widget";
import { Typography as MuiTypography } from "../../components/Wrappers";
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import firebase from "../../firebase.js"

var database = firebase.database();

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export default function DefectData() {
  var classes = useStyles();

  var datatableData = [];
  const defaultDate = new Date("2020-12-18");
  const [startDateState, setStartDate] = React.useState(defaultDate);
  const [endDateState, setEndDate] = React.useState(defaultDate);
  var [lineState, setLineState] = useState("B");
  var [dataState, setLossDataState] = useState(datatableData);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  useEffect(() => {
    console.log(formatDate(startDateState));
    var ref = database.ref('ENS5/zone/'+lineState+'/Defect Data').orderByKey().startAt(formatDate(startDateState)).endAt(formatDate(endDateState));
    ref.on('value', function(snapshot) {
      var newDatatableData = [];
      snapshot.forEach(function(dateSnapshot) {
        dateSnapshot.forEach(function(shiftSnapshot){
          shiftSnapshot.forEach(function(defectSnapshot){
            newDatatableData.push([
              dateSnapshot.key, 
              shiftSnapshot.key, 
              defectSnapshot.child("Defect Name").val(), 
              defectSnapshot.child("Subcategory").val(),
              defectSnapshot.child("Observation").val(),
              defectSnapshot.child("Category").val(),
              defectSnapshot.child("Engine Number").val(),
              defectSnapshot.child("Engine Model").val(),
              defectSnapshot.child("Zone").val(),
              defectSnapshot.child("Station").val(),
              defectSnapshot.child("Detected At").val(),
              defectSnapshot.child("Rectification Status").val(),
              defectSnapshot.child("Operator Code").val(),
              defectSnapshot.child("Timestamp").val(),
              defectSnapshot.child("AddRemarks").val(),
            ]);
          });
        });
      });
  
      setLossDataState(newDatatableData);
      console.log(dataState);
    });
  
    return () => {
      ref.off();
    };
  }, [startDateState, endDateState, lineState]);
  
  

  const [expandedRows, setExpandedRows] = useState([]);

  const handleToggleRow = (rowId) => {
    setExpandedRows((prevRows) =>
      prevRows.includes(rowId)
        ? prevRows.filter((row) => row !== rowId)
        : [...prevRows, rowId]
    );
  };

  const isRowExpanded = (rowId) => expandedRows.includes(rowId);
  
  // Calculate station frequencies
  const stationFrequencies = dataState.reduce((acc, [, , , , , , , , , station]) => {
    acc[station] = (acc[station] || 0) + 1;
    return acc;
  }, {});

  // Convert station frequencies to arrays for chart data
  const chartData = {
    labels: Object.keys(stationFrequencies),
    datasets: [
      {
        label: "Defects by Station",
        backgroundColor: "rgba(75,192,192,1)",
        borderColor: "rgba(0,0,0,1)",
        borderWidth: 2,
        data: Object.values(stationFrequencies),
      },
    ],
  };
  // Calculate operator frequencies
  const operatorFrequencies = dataState.reduce(
    (acc, [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      operator,
    ]) => {
      acc[operator] = (acc[operator] || 0) + 1;
      return acc;
    },
    {}
  );

  // Convert operator frequencies to arrays for chart data
  const operatorChartData = {
    labels: Object.keys(operatorFrequencies),
    datasets: [
      {
        label: "Defects by Operator",
        backgroundColor: "rgba(75,192,192,1)",
        borderColor: "rgba(0,0,0,1)",
        borderWidth: 2,
        data: Object.values(operatorFrequencies),
      },
    ],
  };

  // Calculate category frequencies
  const categoryFrequencies = dataState.reduce(
    (acc, [, , , , , category]) => {
      // Log the category value to identify if it's undefined
      console.log("Category:", category);
      
      acc[category] = (acc[category] || 0) + 1;
      return acc;
    },
    {}
  );

  // Convert category frequencies to arrays for chart data
  console.log("Category Frequencies:", categoryFrequencies);

  // Convert category frequencies to arrays for chart data
  const categoryChartData = Object.entries(categoryFrequencies).map(
    ([name, count]) => ({ name, count })
  );

  // Log the entire categoryChartData array
  console.log("Category Chart Data:", categoryChartData);

  
  return (
    <>
      <PageTitle title="Defect Data" />
      <Grid
        align="center"
        alignItems="center"
        container
        spacing={4}
        justify="space-between"
      >
        <Grid item lg={4} md={6} sm={6} xs={12}>
          <Select
            value={lineState}
            onChange={(e) => setLineState(e.target.value)}
            input={<OutlinedInput labelWidth={0} />}
            autoWidth
          >
            <MenuItem value="B">B zone</MenuItem>
            <MenuItem value="C">C zone</MenuItem>
            <MenuItem value="TESTING">Testing</MenuItem>
            <MenuItem value="DRESSING">Dressing</MenuItem>
            <MenuItem value="RECTIFICATION">Rectification</MenuItem>
          </Select>
        </Grid>
        <Grid item lg={4} md={6} sm={6} xs={12}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              margin="normal"
              id="date-picker-dialog"
              label="Start Date"
              format="yyyy-MM-dd"
              value={startDateState}
              onChange={handleStartDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item lg={4} md={6} sm={6} xs={12}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              margin="normal"
              id="date-picker-dialog"
              label="End Date"
              format="yyyy-MM-dd"
              value={endDateState}
              onChange={handleEndDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
      {/*<Grid
        align="center"
        alignItems="center"
        container
        spacing={4}
        justify="space-between"
      >
      <Grid item lg={4} md={6} sm={6} xs={4}>
          <Typography variant="h6">Defects by Station</Typography>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={chartData.labels.map((label, index) => ({
                station: label,
                count: chartData.datasets[0].data[index],
              }))}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis dataKey="station" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar
                dataKey="count"
                fill={chartData.datasets[0].backgroundColor}
              />
            </BarChart>
          </ResponsiveContainer>
        </Grid>
        <Grid item lg={4} md={6} sm={6} xs={4}>
          <Typography variant="h6">Defects by Operator</Typography>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={operatorChartData.labels.map((label, index) => ({
                operator: label,
                count: operatorChartData.datasets[0].data[index],
              }))}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis dataKey="operator" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar
                dataKey="count"
                fill={operatorChartData.datasets[0].backgroundColor}
              />
            </BarChart>
          </ResponsiveContainer>
        </Grid>
        <Grid item lg={4} md={6} sm={6} xs={4}>
      <Typography variant="h6">Defects by Category</Typography>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={categoryChartData}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" fill="#4bc0c0" />
        </BarChart>
      </ResponsiveContainer>
    </Grid>
        </Grid>*/}
      <Grid container spacing={4}>
        <Grid item xs={12}>
          {dataState.map(
            (
              [
                Date,
                Shift,
                DefectName,
                Subcategory,
                Observation,
                Category,
                EngineNumber,
                EngineModel,
                Zone,
                Station,
                DetectedAt,
                RectificationStatus,
                OperatorCode,
                Timestamp,
                AddRemarks,
              ],
              index
            ) => {
              console.log(`Rendering item at index ${index}`);
              console.log('Current data:', {
                Date,
                Shift,
                DefectName,
                // ... log other relevant data
              });
              return (
              <ExpansionPanel
                key={index}
                expanded={isRowExpanded(index)}
                onChange={() => handleToggleRow(index)}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                >
                  <MuiTypography>{`${Date} - ${Shift} - ${EngineNumber} - ${DefectName}`}</MuiTypography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Typography>
                    <strong>Defect Name:</strong> {DefectName}
                    <br />
                    <strong>Subcategory:</strong> {Subcategory}
                    <br />
                    <strong>Observation:</strong> {Observation}
                    <br />
                    <strong>Category:</strong> {Category}
                    <br />
                    <strong>Engine Model:</strong> {EngineModel}
                    <br />
                    <strong>Zone:</strong> {Zone}
                    <br />
                    <strong>Station:</strong> {Station}
                    <br />
                    <strong>Operator Code:</strong> {OperatorCode}
                    <br />
                    <strong>Detected At:</strong> {DetectedAt}
                    <br />
                    <strong>Rectification Status:</strong> {RectificationStatus}
                    <br />
                    <strong>Timestamp:</strong> {Timestamp}
                    <br />
                    <strong>Add Remarks:</strong> {AddRemarks}
                  </Typography>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            );
            }
          )}
        </Grid>
      </Grid>
    </>
  );
}
